import { Component } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatIcon } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-faqs-settings',
    templateUrl: './faqs-settings.component.html',
    styleUrls: ['./faqs-settings.component.scss'],
    imports: [ReactiveFormsModule, FormsModule, MatFormField, MatLabel, MatInput, MatIcon, MatButton]
})
export class FaqsSettingsComponent {

}
